var _path, _path2, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 314,
    viewBox: "0 0 340 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4303 308.741C19.9303 308.741 -7.66974 297.682 13.9303 253.443C35.5303 209.204 71.9303 214.585 87.9303 219.567L146.657 238.48C168.419 205.568 172.117 105.62 172.93 97.512C173.93 87.5484 163.43 33.2466 218.93 34.7411C292.13 43.9076 287.764 70.4441 276.43 82.5666C269.097 89.0429 247.33 101.099 218.93 97.512C223.435 113.596 213.847 204.666 201.381 256.432L297.43 287.319C303.93 289.312 376.93 308.741 297.43 308.741H41.9303H36.4303Z",
    fill: "#81B757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9303 308.741H297.43C376.93 308.741 303.93 289.312 297.43 287.319L201.381 256.432M41.9303 308.741H36.4303C19.9303 308.741 -7.66974 297.682 13.9303 253.443C35.5303 209.204 71.9303 214.585 87.9303 219.567L146.712 238.498M41.9303 308.741C84.9303 308.575 174.43 304.756 188.43 290.807C205.93 273.37 224.93 118.934 218.93 97.512C247.33 101.099 269.097 89.0429 276.43 82.5666C287.764 70.4441 292.13 43.9076 218.93 34.7411C163.43 33.2466 173.93 87.5484 172.93 97.512C172.013 106.652 167.43 232.519 137.43 247.465C118.43 262.908 92.9303 262.908 75.4303 262.908",
    stroke: "black",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 44.7108,
    width: 3,
    height: 31,
    fill: "#FF5964"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 35.0921,
    width: 47,
    height: 25,
    transform: "rotate(-31.2486 162 35.0921)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144.209,
    y: 40.0044,
    width: 77.1164,
    height: 8.97785,
    transform: "rotate(-31.2486 144.209 40.0044)",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoaLogo);
export default __webpack_public_path__ + "static/media/BOALogo.d16ed5bcb28663910a4d94e5dc1ad024.svg";
export { ForwardRef as ReactComponent };